export const dateLocal=(dt,type)=>{
    if(type===1){
        // where dt= 20231026 like this format
        var main_dt = dt;
		var dtYY = main_dt.slice(0,4);
		var dtMM = main_dt.slice(4,6);
		var dtDD = main_dt.slice(6,8);
        let full_dat = `${dtDD}-${dtMM}-${dtYY}`;
        return (full_dat);
    }else if(type===2){
         // where dt= 2023-10-26 like this format
       let dateinDMY= new Date(dt).toJSON().slice(0,10).split('-').reverse().join('-');
       return (dateinDMY);
    }
}

export const dateInDMY = (date)=>{
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [day,month,year].join('-');
}

export const superAdmin = (user)=>{
    /* check if super admin then user_role will be 1 */
    const is_admin_role = user.user_role;
    if(is_admin_role==='1'){
        return true;
    }else{
        return false;
    }
}

export const isAdmin = (user)=>{
    /* check if admin then user_role will be 1 or 2 */
    const is_admin_role = user.user_role;
    if(is_admin_role==='1' || is_admin_role==='2'){
        return true;
    }else{
        return false;
    }
}

export const hasRight_Old = (user, user_right)=>{
    /* check if admin then user_role will be 1 or 2 */
    const is_admin = user.user_role;
    if(is_admin==='1' || is_admin==='2'){
        return true;
    }

    if(user_right!==''){
        const userRole = user?.userrole;
        const right= userRole?.includes(user_right);
        return right;
    }
}

export const hasRight = (user, user_right) => {
    if (!user) return false;

    // Admin roles: 1 and 2
    const role = String(user.user_role);

    if (role === "1" || role === "2") {
        return true;
    }

    if (!user_right) return false;

    const userRole = user.userrole;

    return Array.isArray(userRole) && userRole.includes(user_right);
};


export const hasRightNoAdmin = (user, user_right) => {
    if (!user) return false;

    const role = String(user.user_role);

    if (role === "1") {
        return true;
    }

    if (!user_right) return false;

    const userRole = user.userrole;

    return Array.isArray(userRole) && userRole.includes(user_right);
};
